import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreAction } from "../../@core/constants";

export const getAllCategoryListAction = createAsyncThunk(
  "",
  async (data, { dispatch }) =>
    dispatch({ type: StoreAction.SET_CATEGORY, payload: data })
);

// create category
export const insertCategoryListAction = createAsyncThunk(
  "",
  async (data, { dispatch, getState }) => {
    const state = getState();
    return dispatch({
      type: StoreAction.SET_CATEGORY,
      payload: [...state.templateReducer.categoryDataList, { ...data }],
    });
  }
);

// update category
export const updateCategoryAction = createAsyncThunk(
  "",
  async (data, { dispatch, getState }) => {
    const state = getState();
    const allCategory = state.templateReducer.categoryDataList;
    const newCategoryList = allCategory.map((category) => {
      return category.waba_tc_id == data?.waba_tc_id
        ? (category = data)
        : category;
    });
    return dispatch({
      type: StoreAction.SET_CATEGORY,
      payload: newCategoryList,
    });
  }
);

export const deleteCategoryAction = createAsyncThunk(
  "",
  async (waba_tc_id, { dispatch, getState }) => {
    const state = getState();
    let category = state.templateReducer.categoryDataList;
    let newdata = category.filter((a) => {
      return a.waba_tc_id != waba_tc_id;
    });
    return dispatch({
      type: StoreAction.SET_CATEGORY,
      payload: newdata,
    });
  }
);

export const getAllLanguagesAction = createAsyncThunk(
  "",
  async (data, { dispatch }) =>
    dispatch({ type: StoreAction.SET_LANGUAGES, payload: data })
);

export const getTempCategoryListAction = createAsyncThunk(
  "",
  async (data, { dispatch }) =>
    dispatch({ type: StoreAction.GET_TEMP_CATEGORY, payload: data })
);

// Set Current Business Template List Action
export const setTemplateListAction = createAsyncThunk(
  "",
  async (templateList, { dispatch, getState }) => {
    const state = getState();

    const newTemplateList = [
      ...state?.templateReducer?.templateList,
      ...templateList,
    ];

    // Remove duplicates Records
    const finalData = newTemplateList.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.waba_t_id === item.waba_t_id)
    );
    return dispatch({
      type: StoreAction.SET_TEMPLATE_LIST,
      payload: finalData,
    });
  }
);

// Replace Template List State Action (Server Side Pagination)
export const replaceTemplateListAction = createAsyncThunk(
  "",
  async (templateList, { dispatch }) =>
    dispatch({
      type: StoreAction.SET_TEMPLATE_LIST,
      payload: templateList,
    })
);

// Delete Template Record Action
export const deleteTemplateRecordAction = createAsyncThunk(
  "",
  async (templateId, { dispatch, getState }) => {
    const state = getState();
    const updatedTemplateList = state?.templateReducer?.templateList.filter(
      (items) => items.waba_t_id !== templateId
    );
    return dispatch({
      type: StoreAction.SET_TEMPLATE_LIST,
      payload: updatedTemplateList,
    });
  }
);

// Update Single Template Record Action (e.g. mark edited template as Pending)
export const updateTemplateRecordAction = createAsyncThunk(
  "",
  async ({ templateId, data }, { dispatch, getState }) => {
    const state = getState();
    const updatedTemplateList = state?.templateReducer?.templateList.map(
      (item) =>
        item.waba_t_id === templateId ? { ...item, ...data } : item
    );
    return dispatch({
      type: StoreAction.SET_TEMPLATE_LIST,
      payload: updatedTemplateList,
    });
  }
);

// Clear Template List State Action
export const clearTemplateListAction = createAsyncThunk(
  "",
  async (templateList, { dispatch }) =>
    dispatch({
      type: StoreAction.SET_TEMPLATE_LIST,
      payload: templateList,
    })
);
